import { render, staticRenderFns } from "./ProductPPLSnew.vue?vue&type=template&id=1a29f1db&"
import script from "./ProductPPLSnew.vue?vue&type=script&lang=js&"
export * from "./ProductPPLSnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports